export default __webpack_public_path__ + "static/media/seat-rounded.a7bfcfa8.webp";